import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import type { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { ProtectionType } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'

interface EventItem {
  name: string
  count: number
  type: ProtectionType
}


export default /*#__PURE__*/_defineComponent({
  __name: 'infection-phase-events',
  props: {
    data: { default: () => [] },
    timeRange: { default: TimeRange.ALL }
  },
  emits: ["update:timeRange", "rowClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const timeRange = computed<TimeRange>({
  get: () => (typeof props.timeRange === 'string' ? (props.timeRange as TimeRange) : props.timeRange) || TimeRange.ALL,
  set: (val) => emit('update:timeRange', val as TimeRange | string)
})

const rankingData = computed<RankingItem[]>(() => {
  return [...props.data]
    .sort((a, b) => b.count - a.count)
    .map((item) => ({
      name: item.name,
      count: item.count,
      type: item.type,
    }))
})

function handleItemClick(item: RankingItem) {
  if (!(item.count > 0) || item.type == null) return
  emit('rowClick', {
    type: item.type as ProtectionType,
    count: item.count,
    chartTimeRange: timeRange.value,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('ransomwareIncident.infectionPhaseTitle'),
    data: rankingData.value,
    "time-range": timeRange.value,
    "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
    "show-time-range": true,
    "show-all": true,
    "show-index": true,
    unit: _ctx.$t('ransomwareIncident.unitTimes'),
    "name-key": "name",
    "row-clickable": "",
    onItemClick: handleItemClick
  }, null, 8, ["title", "data", "time-range", "unit"]))
}
}

})